import React, { useEffect, useState } from 'react'
import axios from "axios";
import { Auth } from "aws-amplify";
import { AlertTitle, Button, Chip, CircularProgress, DialogContent, DialogTitle, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Select, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Tooltip } from '@mui/material'
import MuiAlert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CancelIcon from '@mui/icons-material/Cancel';
import MusicOffIcon from '@mui/icons-material/MusicOff';
import ErrorIcon from '@mui/icons-material/Error';
import CommentsDisabledIcon from '@mui/icons-material/CommentsDisabled';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import TabletMacIcon from '@mui/icons-material/TabletMac';
import AssignmentIcon from '@mui/icons-material/Assignment';

const StudentReport = ( {handleClose, testId, lang, allLangs, error, reportJson, setReportJson, studentsData, setStudentsData, audioRef} ) => {
  const [tabValue, setTabValue] = useState(0);
  const [studentRateForm, setStudentRateForm] = useState({score: "", comment: ""});
  const [studentRateFormError, setStudentRateFormError] = useState({score: false, comment: false});
  const [studentRateFormState, setStudentRateFormState] = useState({submitting: false, submitted: true});

  const { t } = useTranslation();

  useEffect(() => {
    if(reportJson!==""){
      let reportLangs = reportJson.reportCard.map(item => item.lang)
      if(reportLangs.includes(lang)) setTabValue(reportLangs.indexOf(lang)) // selecting the lang if it is passed to this component
      else setTabValue(0)
      // if lang is passed use that for checking the rating else use first lang of report
      let firstLang = lang ? lang : reportLangs[0]
      // console.log(reportLangs)
      // get previous student rating
      let studentRatings = reportJson.studentRatings
      if(Object.keys(studentRatings).length === 0){   // if no previous rating found
        setStudentRateForm(prev => ({...prev, score: "", comment: ""}));
        setStudentRateFormState(prev => ({...prev, submitted: false}));
      }
      else if(Object.keys(studentRatings).includes(firstLang)){    // previous rating found with first lang
        studentRatings = studentRatings[firstLang][0]
        setStudentRateForm(prev => ({...prev, score: studentRatings.score, comment: studentRatings.comment}));
        setStudentRateFormState(prev => ({...prev, submitted: true}));
      }
      else{   // previous rating found but not matching first lang
        setStudentRateForm(prev => ({...prev, score: "", comment: ""}));
        setStudentRateFormState(prev => ({...prev, submitted: false}));
      }
    }
  }, [reportJson, lang])

  const handleTabChange = (e, newLangIndex) => {
    if(reportJson!=="" && Object.keys(reportJson.studentRatings).length !== 0){
      let studentRatings = reportJson.studentRatings
      let reportLang = reportJson.reportCard[newLangIndex].lang
      if(Object.keys(studentRatings).includes(reportLang)){
        studentRatings = studentRatings[reportLang][0]
        setStudentRateForm(prev => ({...prev, score: studentRatings.score, comment: studentRatings.comment}))
        setStudentRateFormState(prev => ({...prev, submitted: true}));
      }
      else{
        setStudentRateForm(prev => ({...prev, score: "", comment: ""}))
        setStudentRateFormState(prev => ({...prev, submitted: false}));
      }
    }
    setTabValue(newLangIndex);
  };

  const pauseAudio = (e) => {
    // console.log(e)
    audioRef.current.filter(i => i !== e.target).map((audio => audio.pause()))
  }

  var filteredThresholds = null
  if(reportJson!==""){
    filteredThresholds = reportJson.thresholds[reportJson.reportCard[tabValue].lang][0]
  }
  // console.log(thresholds)

  // var cwsnLabels = {
  //   1: "Blindness",
  //   2: "Low-Vision",
  //   3: "Hearing impairment",
  //   4: "Speech and Language",
  //   5: "Locomotor Disability",
  //   6: "Mental illness",
  //   7: "Specific Learning Disabilities",
  //   8: "Cerebral palsy",
  //   9: "Autism Spectrum Disorder",
  //   10: "Multiple Disability incl. deaf blindness",
  //   11: "Leprosy Cured students",
  //   12: "Dwarfism",
  //   13: "Intellectual Disability",
  //   14: "Muscular Dystrophy",
  //   15: "Chronic Neurological conditions",
  //   16: "Multiple Sclerosis",
  //   17: "Thalassemia",
  //   18: "Haemophilia",
  //   19: "Sickle Cell disease",
  //   20: "Acid Attack victim",
  //   21: "Parkinson's disease",
  //   99: "Not Applicable",
  // }

  const handleStudentRateFormChange = (field, value) => {
    // console.log(value)
    setStudentRateForm(prev => ({...prev, [field]: value}))
    if(field === "comment"){
      // This checks that comment atleast 1 to 32 A to Z a to z and digits & checks for any whitespace character at the start of string
      if((/^(?!\s)[A-Za-z\d_\-"'.,!?()\n ]{1,256}$/).test(value)) setStudentRateFormError(prev => ({...prev, [field]: false}))   // \d is same as 0-9
      else setStudentRateFormError(prev => ({...prev, [field]: true}))
    }
  }

  // submit
  const handleSubmit = () => {
    if(studentRateForm.score===""){
      setStudentRateFormError(prev => ({...prev, score: true}));
      return
    }
    if(studentRateForm.comment===""){
      setStudentRateFormError(prev => ({...prev, comment: true}));
      return
    }
    if(!(/^(?!\s)[A-Za-z\d_\-"'.,!?()\n ]{1,256}$/).test(studentRateForm.comment)) {
      // setToastType(["warning", "Please fill all the required fields!"])
      // setToastOpen(true)
      return
    }
    setStudentRateFormState(prev => ({...prev, submitting: true}));
    Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;
        const expertId = data.idToken.payload["custom:db_id"]

        const addStudentRating = async(expertId, testId, orgStudId, lang, score, comment) => {
          try {
            const response =  await axios.post("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/expert/"+expertId+"/student-rating",
              JSON.stringify({
                "orgStudId": orgStudId,
                "testId": testId,
                "lang": lang,
                "score": score,
                "comment": comment
              }), 
              {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwtToken
                }
            });
            // console.log(response.data)
            if(response.data.status === "success") {
              alert(response.data.message);
              setStudentRateFormState(prev => ({...prev, submitting: false, submitted: true}));
              setReportJson(prev => ({...prev, "studentRatings": {...prev.studentRatings, [lang]: [{"score": score, "comment": comment}]}}))
              if(Object.keys(studentsData).length !==0 && Object.keys(studentsData).includes("studentRatings") && studentsData?.students.map(item => item.orgStudId).includes(orgStudId)){
                if(Object.keys(studentsData.studentRatings).includes(lang)) setStudentsData(prev => ({...prev, "studentRatings": {...prev.studentRatings, [lang]: [...prev.studentRatings[lang], orgStudId]}}))
                else setStudentsData(prev => ({...prev, "studentRatings": {...prev.studentRatings, [lang]: [orgStudId]}}))
              }
            }
            else{
              alert("Rating Not Updated: \n"+response.data.message)
              setStudentRateFormState(prev => ({...prev, submitting: false}));
            }
          }
          catch (error) {
            alert(t("commonItems.error_api_generic"))
            console.log(error)
            setStudentRateFormState(prev => ({...prev, submitting: false}));
          }
        }

        addStudentRating(
          expertId, 
          testId, 
          Object.keys(reportJson.studentDetails).includes("orgStudId") ? reportJson.studentDetails.orgStudId : reportJson.studentDetails.id, 
          reportJson.reportCard[tabValue].lang, 
          studentRateForm.score, 
          studentRateForm.comment
        )
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <DialogTitle sx={{display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap"}}>
        <AssessmentIcon color="info" sx={{fontSize: "1.25rem"}}/>
        <b>{t("facilitator.results.studentReportDialogue.title")}</b>
        {reportJson && 
          <p style={{fontWeight: "bold", fontSize: "0.67em", marginLeft: "auto", marginRight: "20px"}}>
            {"Grade " + reportJson.studentDetails.grade + ", " + reportJson.studentDetails.region}
          </p>
        }
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <div className='studentReport innerContent'>
          {/* <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>Student Report</h2> */}
          {reportJson ?
          <>
            <div className="countTileContainer" style={{padding: "unset", gap: "unset", alignItems: "baseline"}}>
              <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
                <AssignmentIcon fontSize="small"/>
                <span style={{height: "100%"}}>{t("commonItems.studentRatingLabel")}</span> 
              </h4>
              <FormControl sx={{ m: 1, minWidth: 150}} size="small">
                <InputLabel id="langFilterLabel">{t("commonItems.dropdownLabel_lang")}</InputLabel>
                <Select
                  labelId="langFilterLabel"
                  id="langFilter"
                  value={tabValue}
                  onChange={(e) => handleTabChange(e, e.target.value)}
                  autoWidth
                  label={t("commonItems.dropdownLabel_lang")}
                >
                  {reportJson.reportCard.map((item, i) => {
                    return <MenuItem key = {i} value={i}>
                              {Object.keys(allLangs).includes(item.lang) ? allLangs[item.lang] : item.lang}
                            </MenuItem>
                  })}
                </Select>
              </FormControl>
              <FormControl sx={{ m: 1, minWidth: 100}} size="small" required error={studentRateFormError.score}>
                <InputLabel id="scoreFilterLabel">{t("commonItems.dropdownLabel_score")}</InputLabel>
                <Select
                  labelId="scoreFilterLabel"
                  id="scoreFilter"
                  value={studentRateForm.score}
                  onChange={(e) => handleStudentRateFormChange("score", e.target.value)}
                  autoWidth
                  label={t("commonItems.dropdownLabel_score")}
                  disabled={studentRateFormState.submitting || studentRateFormState.submitted}
                >
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={6}>6</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                    <MenuItem value={8}>8</MenuItem>
                    <MenuItem value={9}>9</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                </Select>
                {studentRateFormError.score && 
                  <FormHelperText>Required</FormHelperText>
                }
              </FormControl>
              <FormControl sx={{ m: 1, minWidth: 150}}>
                <TextField
                  error = {studentRateFormError.comment} 
                  helperText = {studentRateFormError.comment ? "Comment must contain only letters, digits and common punctuations upto 256 characters" : false} 
                  required
                  // margin="dense"
                  id="comment"
                  name={t("commonItems.textfieldLabel_comment")}
                  label={t("commonItems.textfieldLabel_comment")}
                  variant="outlined"
                  size="small"
                  value={studentRateForm.comment}
                  multiline={true}
                  minRows={3}
                  onChange={(e) => handleStudentRateFormChange("comment", e.target.value)}
                  sx={{minWidth: "400px", maxWidth: "400px"}}
                  disabled={studentRateFormState.submitting || studentRateFormState.submitted}
                />
              </FormControl>
              <Button 
                // size="small"
                onClick={handleSubmit}
                disabled={studentRateForm.score === "" || studentRateForm.comment === "" || studentRateFormError.comment || studentRateFormState.submitting || studentRateFormState.submitted}
                variant="contained" 
              >
                {studentRateFormState.submitting ? 
                  <>
                    {t("expert.rateStudents.buttonLabel_submitRating")}<CircularProgress size="1rem" color="inherit" sx={{marginLeft: "0.25rem"}}/>
                  </> 
                : studentRateFormState.submitted ? 
                  <>
                    {t("expert.rateStudents.buttonLabel_submitted")}<CheckCircleIcon size="1rem" color="inherit" sx={{marginLeft: "0.25rem"}}/>
                  </> 
                : 
                  <>
                    {t("expert.rateStudents.buttonLabel_submitRating")}
                  </>
                }
                  
              </Button>
              {/* <div className="countTile" style={{gap: "0.5rem"}}>
                <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_name")}:</div>
                <div className="countTileRight">{
                  reportJson.ver === "1" ?
                    reportJson.studentDetails.firstName.toUpperCase() + " " + reportJson.studentDetails.lastName.toUpperCase()
                  :
                    reportJson.studentDetails.studentName.toUpperCase()
                }
                </div>
              </div>
              {reportJson.ver === "1" ?
                <div className="countTile" style={{gap: "0.5rem"}}>
                  <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_penNo")}:</div>
                  <div className="countTileRight">{reportJson.studentDetails.id}</div>
                </div>
              :
                <div className="countTile" style={{gap: "0.5rem"}}>
                  <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_orgStudId")}:</div>
                  <div className="countTileRight">{reportJson.studentDetails.orgStudId}</div>
                </div>
              }
              <div className="countTile" style={{gap: "0.5rem"}}>
                <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_class")}:</div>
                <div className="countTileRight">{reportJson.studentDetails.grade}</div>
              </div>
              <div className="countTile" style={{gap: "0.5rem"}}>
                <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_section")}:</div>
                <div className="countTileRight">{reportJson.studentDetails.div}</div>
              </div>
              <div className="countTile" style={{gap: "0.5rem"}}>
                <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_rollNo")}:</div>
                <div className="countTileRight">{reportJson.studentDetails.rollNo}</div>
              </div>
              <div className="countTile" style={{gap: "0.5rem"}}>
                <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_gender")}:</div>
                <div className="countTileRight">{reportJson.studentDetails.gender}</div>
              </div>
              {reportJson.ver !== "1" &&
                <div className="countTile" style={{gap: "0.5rem"}}>
                  <div className="countTileLeft">{t("facilitator.results.studentReportDialogue.studDetailsLabel_cwsnCategory")}:</div>
                  <div className="countTileRight">{cwsnLabels[reportJson.studentDetails.cwsn]}</div>
                </div>
              } */}
            </div>
            <div>
              <Tabs value={tabValue} onChange={handleTabChange} sx={{minHeight: "30px"}}>
                {reportJson.reportCard.map((item, i) => {
                  return <Tab 
                            key = {i}
                            label={Object.keys(allLangs).includes(item.lang) ? allLangs[item.lang] : item.lang} 
                            sx={{fontSize: "inherit", 
                            minHeight: "30px"}}
                          />
                })}
              </Tabs>
            </div>
            <div className="reportContainer">
              <div className="reportContainerLeft">
                <div className="paraContainer paraContainerTop">
                  <div style={{flexBasis: "100%"}}><h4>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_storyRead")}: {reportJson.reportCard[tabValue].storyTitle}</h4></div>
                  <p>
                    {t("facilitator.results.studentReportDialogue.reportDetailsLabel_wcpm") }
                        {" "}
                        <Tooltip 
                          enterTouchDelay={50} 
                          arrow 
                          title={<span className="fontFamily-Montserrat">Words Correct Per Minute. The total number of words correctly read in a minute.</span>}>
                            <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                        </Tooltip>  
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.wcpm >= 0 ? 
                        reportJson.reportCard[tabValue].reportCard.wcpm : "NA"
                      }

                      </b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_readingAccuracy")}
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Percentage of words correctly read.</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.readingAccuracy >=0 ? 
                        reportJson.reportCard[tabValue].reportCard.readingAccuracy + "%" : "NA"
                      }
                    </b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_pace")}
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Reading speed</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.sr !== -1 ? 
                          filteredThresholds ?
                            (
                              parseFloat(reportJson.reportCard[tabValue].reportCard.sr) <= parseFloat(filteredThresholds.paceT1) ? t("commonItems.textLabel_pace1", {pace: reportJson.reportCard[tabValue].reportCard.sr}) :
                              parseFloat(reportJson.reportCard[tabValue].reportCard.sr) <= parseFloat(filteredThresholds.paceT2) ? t("commonItems.textLabel_pace2", {pace: reportJson.reportCard[tabValue].reportCard.sr}) :
                              parseFloat(reportJson.reportCard[tabValue].reportCard.sr) <= parseFloat(filteredThresholds.paceT3) ? t("commonItems.textLabel_pace3", {pace: reportJson.reportCard[tabValue].reportCard.sr}) : 
                              t("commonItems.textLabel_pace4", {pace: reportJson.reportCard[tabValue].reportCard.sr})
                            )
                          :
                            <>
                              Contact TARA Admin 
                              <Tooltip 
                                enterTouchDelay={50} 
                                arrow 
                                title={"Pace cannot be computed"}>
                                  <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                              </Tooltip> 
                            </>
                        : "NA"
                      }</b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_wordMistakes")} 
                    {" "}
                    <Tooltip 
                      enterTouchDelay={50} 
                      arrow 
                      title={<span className="fontFamily-Montserrat">Total number of words which were incorrectly read, omitted and includes words that have not been attempted.</span>}>
                        <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                    </Tooltip> 
                    : {" "}
                    <b>{
                      reportJson.reportCard[tabValue].reportCard.noMiscues !== -1 ? 
                      reportJson.reportCard[tabValue].reportCard.noMiscues : "NA"
                    }
                    </b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_practiceWords")} 
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Common list of words on which the child has always made mistakes.</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.practiceWords.length ? 
                        reportJson.reportCard[tabValue].reportCard.practiceWords.toString() : "-"
                      }</b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_phrasing")} 
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Appropriate grouping of words, pausing at commas and stopping at full stops.</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        parseFloat(reportJson.reportCard[tabValue].reportCard.phrasingScore) >=0 ? 
                          filteredThresholds ?
                            (
                              parseFloat(reportJson.reportCard[tabValue].reportCard.phrasingScore) >= parseFloat(filteredThresholds.phrasingT1) ? t("commonItems.textLabel_phrasing1") :
                              parseFloat(reportJson.reportCard[tabValue].reportCard.phrasingScore) >= parseFloat(filteredThresholds.phrasingT2) ? t("commonItems.textLabel_phrasing2") :
                              parseFloat(reportJson.reportCard[tabValue].reportCard.phrasingScore) >= parseFloat(filteredThresholds.phrasingT3) ? t("commonItems.textLabel_phrasing3") : 
                              t("commonItems.textLabel_phrasing4")
                            )
                          :
                            <>
                              Contact TARA Admin 
                              <Tooltip 
                                enterTouchDelay={50} 
                                arrow 
                                title={"Phrasing cannot be computed"}>
                                  <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                              </Tooltip> 
                            </>
                        : <>
                          NA 
                          <Tooltip 
                            enterTouchDelay={50} 
                            arrow 
                            title={"Phrasing is only computed for WCPM>=85 & Reading Accuracy>=90%"}>
                              <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                          </Tooltip> 
                        </>
                      }</b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_improperPhraseBreaks")} <span style={{color: "red"}}><b>||</b></span>
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Break in reading at non-ideal locations.</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.phrasingScore >=0 ? 
                        reportJson.reportCard[tabValue].reportCard.phrasingMiscues.i : "NA"
                      }</b>
                  </p>
                  <p>{t("facilitator.results.studentReportDialogue.reportDetailsLabel_missedPhraseBreaks")} <span style={{color: "#3E008E"}}><b>||</b></span> 
                      {" "}
                      <Tooltip 
                        enterTouchDelay={50} 
                        arrow 
                        title={<span className="fontFamily-Montserrat">Missing breaks at compulsory locations like full stops.</span>}>
                          <IconButton size="small" sx={{padding: 0, color: "#FFF"}}><InfoIcon fontSize='small'/></IconButton>
                      </Tooltip> 
                      : {" "}
                      <b>{
                        reportJson.reportCard[tabValue].reportCard.phrasingScore >=0 ? 
                        reportJson.reportCard[tabValue].reportCard.phrasingMiscues.m : "NA"
                      }</b>
                  </p>
                </div>
                {reportJson.reportCard[tabValue].reportCard.paraResults.map((item, i) => {
                  return <div key = {i} className="paraContainer">
                          <div className="paraDiv">
                            <h4>{t("facilitator.results.studentReportDialogue.paragraphLabel")}: {item.paraNo}</h4>
                            {item.s3Url !== "" && 
                              <audio
                                ref={ref => audioRef.current[i] = ref}
                                onPlaying={(e) => pauseAudio(e)}
                                // onError={(e) => console.log(e)}
                                controls
                                // controlsList="nodownload noplaybackrate"
                                // src={"https://www.ee.iitb.ac.in/LMEDS/audio_examples/KV/audios/27179910008431_1700296121306_Para2-Take1.m4a"}
                                src={item.s3Url}
                                style={{height: "2rem", borderRadius: "10px", border: "1px solid #242d49"}}
                              />
                            }
                            {item.resultStatus === 1 && <Chip icon={<CommentsDisabledIcon/>} color='error' label="Incomplete Attempt" /> }
                            {item.resultStatus === 2 && <Chip icon={<MusicOffIcon/>} color='error' label="Blank Audio" /> }
                            {item.resultStatus === 3 && <Chip icon={<ErrorIcon/>} color='error' label="Missing Audio" /> }
                          </div>
                          <p style={{marginTop: "0.5rem"}}>
                            {item.wordFeedback.map((w, i) => {
                                return <React.Fragment key={i}>
                                  {" "}
                                  {
                                    w.miscueLabel === "c" ? <span>{w.promptWord}</span> :
                                    w.miscueLabel === "i" ? "" :
                                    // w.miscueLabel === "s" ? <span style={{color: "#3E008E"}}>{w.decodedWord}({w.promptWord})</span> :
                                    w.miscueLabel === "s" ? <span>{w.promptWord}</span> :
                                    w.miscueLabel === "d" ? <span>{w.promptWord}</span> : console.log("Unidentified miscue label: ", w.miscueLabel)
                                  }
                                  {/* {
                                    w.miscueLabel === "c" ? <span style={{color: "green"}}>{w.promptWord}</span> :
                                    w.miscueLabel === "i" ? <ins>{w.decodedWord}</ins> :
                                    // w.miscueLabel === "s" ? <span style={{color: "#3E008E"}}>{w.decodedWord}({w.promptWord})</span> :
                                    w.miscueLabel === "s" ? <span style={{color: "#3E008E"}}>{w.promptWord}</span> :
                                    w.miscueLabel === "d" ? <del>{w.promptWord}</del> : console.log("Unidentified miscue label: ", w.miscueLabel)
                                  }
                                  {w.pbLabel && " "}
                                  {
                                    w.pbLabel === "" ? "" : 
                                    w.pbLabel === "c" ? <span style={{color: "green", fontFamily: "bold"}}>||</span> :
                                    w.pbLabel === "i" ? <span style={{color: "red", fontFamily: "bold"}}>||</span> :
                                    w.pbLabel === "d" ? <span style={{color: "#3E008E", fontFamily: "bold"}}>||</span> : console.log("Unidentified pb label: ", w.pbLabel)
                                  } */}
                                </React.Fragment>
                              })
                            }
                          </p>
                  </div>  
                })}
              </div>
              <div className="reportContainerRight">
                <div className="attemptContainer">
                  <h4>{t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary")}:</h4>
                  {reportJson.reportCard[tabValue].resultStatus ?
                    <Chip icon={<CancelIcon/>} color='error' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_invalid")} />
                    :
                    <Chip icon={<CheckCircleIcon/>} color='success' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_valid")} />
                  }
                  {[0,3,5].includes(reportJson.reportCard[tabValue].reportCard.micConnected) ?
                    <Chip icon={<CancelIcon/>} color='error' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_noEarphone")} />
                  // : reportJson.reportCard[tabValue].reportCard.micConnected === 1 ?
                  :[1,4,6].includes(reportJson.reportCard[tabValue].reportCard.micConnected) ?
                    <Chip icon={<CheckCircleIcon/>} color='success' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_earphone")} />
                  : 
                    <Chip icon={<HelpIcon/>} color='warning' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_earphoneUnknown")} />
                  }
                  {[0,1].includes(reportJson.reportCard[tabValue].reportCard.micConnected) ?
                    <Chip icon={<AndroidIcon/>} color='info' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_android")}/>
                  :[3,4].includes(reportJson.reportCard[tabValue].reportCard.micConnected) ?
                    <Chip icon={<PhoneIphoneIcon/>} color='info' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_apple")} />
                  :[5,6].includes(reportJson.reportCard[tabValue].reportCard.micConnected) ?
                    <Chip icon={<TabletMacIcon/>} color='info' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_apple")} /> 
                  :
                    <Chip icon={<AppleIcon/>} color='info' label={t("facilitator.results.studentReportDialogue.summaryLabel_attemptSummary_apple")} />
                  }
                </div>
                <div className="legendContainer">
                  <TableContainer style={{width: "unset"}}>
                    <Table size='small'>
                      <TableHead>
                        <TableRow>
                          <TableCell align='center' style={{padding: "6px 6px"}}><h4>{t("facilitator.results.studentReportDialogue.legendLabel_wordMistakes")}</h4></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><span style={{color: "green"}}>{t("facilitator.results.studentReportDialogue.legendLabel_wordMistakes_correct")}</span></TableCell></TableRow>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><span style={{color: "#3E008E"}}>{t("facilitator.results.studentReportDialogue.legendLabel_wordMistakes_substitution")}</span></TableCell></TableRow>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><del>{t("facilitator.results.studentReportDialogue.legendLabel_wordMistakes_deletion")}</del></TableCell></TableRow>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><ins> {t("facilitator.results.studentReportDialogue.legendLabel_wordMistakes_insertion")}</ins></TableCell></TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TableContainer style={{width: "unset"}}>
                    <Table size='small'>
                      <TableHead>
                        <TableRow>
                          <TableCell align='center' style={{padding: "6px 6px"}}><h4>{t("facilitator.results.studentReportDialogue.legendLabel_phraseBreaks")} ||</h4></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><span style={{color: "green"}}>|| - {t("facilitator.results.studentReportDialogue.legendLabel_phraseBreaks_correct")}</span></TableCell></TableRow>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><span style={{color: "red"}}>|| - {t("facilitator.results.studentReportDialogue.legendLabel_phraseBreaks_improper")}</span></TableCell></TableRow>
                        <TableRow><TableCell style={{padding: "6px 6px"}}><span style={{color: "#3E008E"}}>|| - {t("facilitator.results.studentReportDialogue.legendLabel_phraseBreaks_missed")}</span></TableCell></TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </>
          : ( error ?
              <MuiAlert severity={error.status} className="blankScreenError" sx={{borderRadius: "10px"}}>
                <AlertTitle>{error.message}</AlertTitle>
              </MuiAlert>
              :
              <CircularProgress color="info" style={{placeSelf: "center"}}/>) }
        </div>
      </DialogContent>
    </>
  )
}

export default StudentReport